export default {"src":"/_next/static/media/loader.9a7f9f20.gif","height":130,"width":130,"blurWidth":0,"blurHeight":0};